import React from 'react';
import TogetherBanner from 'components/togetherBanner';
import SEO from 'components/seo';
import OurSpinOuts from './ourSpinOuts';
import HeaderWhatWeDo from './headerWhatWeDo';
import WhatWeDo from './whatWeDo';
import CodeExperience from './codeExperience';
import Herotech8Banner from '../../components/herotech8Banner';
import ProjectsClientsLogos from '../../components/projectsClientsLogos';


function WhatWeDoPage() {
  return (
    <>
      <SEO title="What We Do" />
      <HeaderWhatWeDo />
      <WhatWeDo />
      <CodeExperience />
      <OurSpinOuts />
      <ProjectsClientsLogos />
      <Herotech8Banner action="url" />
      <TogetherBanner />
    </>
  );
}

export default WhatWeDoPage;
